import { css } from "styled-components";

const rubikFonts = [
  {
    name: "Light",
    weight: 300,
  },
  {
    name: "Regular",
    weight: 400,
  },
  {
    name: "Medium",
    weight: 500,
  },
  {
    name: "Bold",
    weight: 700,
  },
  {
    name: "Black",
    weight: 900,
  },
];

const rubikFontFaces = rubikFonts.map(
  (font) => css`
    @font-face {
      font-family: "Rubik";
      font-weight: ${font.weight};
      src: url(${require(`../../../static/fonts/Rubik/Rubik-${font.name}.woff2`)})
          format("woff2"),
        url(${require(`../../../static/fonts/Rubik/Rubik-${font.name}.woff`)})
          format("woff"),
        url(${require(`../../../static/fonts/Rubik/Rubik-${font.name}.ttf`)})
          format("truetype");
    }
  `
);

export default rubikFontFaces;
